module.exports = __webpack_public_path__ + "static/media/onboard2.468c80c9.png";